<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        class="content-editor"
        outlined
        height="520px"
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Texto:</h3>

            <v-switch
              v-model="enable_text_landing"
              label="Habilitar texto"
            ></v-switch>
          </v-col>

          <v-col
            cols="12">
            <vue-editor
              class="editor"
              :disabled="!enable_text_landing"
              :editor-toolbar="customToolbar"
              v-model="text_landing">
            </vue-editor>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateTextLanding()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import { VueEditor, Quill } from "vue2-editor";

  const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];
  const fontNames = fontList.map(font => getFontName(font));
  const fonts = Quill.import('formats/font');
  fonts.whitelist = fontNames;
  Quill.register(fonts, true);

  function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

  export default {
    name: 'customizationTextSection',
    components: {
      VueEditor
    },
    data: () => ({
      loading:true,
      loading_update: false,
      landing: [],
      enable_text_landing:false,
      text_landing:'',
      error:false,
      errors:[],
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'align': [] }]
      ],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing
          this.enable_text_landing = (this.landing.enable_text_landing)?true:false
          this.text_landing = this.landing.text_landing

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateTextLanding(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('enable_text_landing', (this.enable_text_landing)?1:0)
        formData.append('text_landing', this.text_landing)

        try {
          await axios({
            method: 'post',
            url: 'admin/landing/text-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          this.loading_btn=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      }
    },

    created(){
      this.getCustomization()
    },
  }
</script>
